import {
    OBTENER_PEDIDOS,
    OBTENER_PEDIDOS_EXITO,
    OBTENER_PEDIDOS_ERROR
} from "../../redux/types";
import clienteAxios from "../../config/axios";
import { handlerError } from "../../utils/handlerError";

// Función que descarga los pedidos de la base de datos
export function obtenerPedidosAction(rutasId) {
  return async (dispatch) => {
    dispatch(descargarPedidos());
    await clienteAxios
      .get(`/buscar?coleccion=rutas_guias&variable=rutas_id&termino=${rutasId}`)
      .then((respuesta) => {
        dispatch(
          descargaPedidosExitosa(respuesta.data)
        );
      })
      .catch((err) => {
        dispatch(descargaPedidosError(handlerError(err)));
      });
  };
}

const descargarPedidos = () => ({
  type: OBTENER_PEDIDOS,
  payload: true,
});

const descargaPedidosExitosa = (pedidos) => ({
  type: OBTENER_PEDIDOS_EXITO,
  payload: pedidos,
});

const descargaPedidosError = (error) => ({
  type: OBTENER_PEDIDOS_ERROR,
  payload: error,
});